// src/components/FloatingWidgets.js
import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaPhone } from 'react-icons/fa';

function FloatingWidgets() {
  const [isVisible, setIsVisible] = useState(true);

  // Phone number for WhatsApp and calls
  const phoneNumber = '447944859580'; // Format: country code + number (no +)
  const whatsappMessage = encodeURIComponent('Hello! I would like to inquire about your repair services.');

  const containerStyle = {
    position: 'fixed',
    bottom: '92px',
    right: '25px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    zIndex: 9998,
    transition: 'all 0.3s ease',
  };

  const widgetButtonStyle = {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '28px',
    color: '#fff',
    boxShadow: '0 4px 12px rgba(108, 117, 125, 0.2)',
    transition: 'all 0.3s ease',
    position: 'relative',
  };

  const whatsappStyle = {
    ...widgetButtonStyle,
    backgroundColor: '#25D366',
  };

  const phoneStyle = {
    ...widgetButtonStyle,
    backgroundColor: '#007BFF',
  };

  const tooltipStyle = {
    position: 'absolute',
    bottom: '70px',
    right: '0',
    backgroundColor: '#6c757d',
    color: '#fff',
    padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    opacity: '0',
    visibility: 'hidden',
    transition: 'all 0.3s ease',
    pointerEvents: 'none',
  };

  const tooltipVisibleStyle = {
    ...tooltipStyle,
    opacity: '1',
    visibility: 'visible',
  };

  const [hoveredWidget, setHoveredWidget] = useState(null);

  // Widgets are always stacked vertically above Tawk.to
  // No responsive changes needed

  if (!isVisible) return null;

  return (
    <div id="floating-widgets-container" style={containerStyle}>
      {/* WhatsApp Widget */}
      <div style={{ position: 'relative' }}>
        <a
          href={`https://wa.me/${phoneNumber}?text=${whatsappMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          style={whatsappStyle}
          onMouseEnter={() => setHoveredWidget('whatsapp')}
          onMouseLeave={() => setHoveredWidget(null)}
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp />
        </a>
        <div style={hoveredWidget === 'whatsapp' ? tooltipVisibleStyle : tooltipStyle}>
          WhatsApp Us
        </div>
      </div>

      {/* Phone Call Widget */}
      <div style={{ position: 'relative' }}>
        <a
          href={`tel:+${phoneNumber}`}
          style={phoneStyle}
          onMouseEnter={() => setHoveredWidget('phone')}
          onMouseLeave={() => setHoveredWidget(null)}
          aria-label="Call us"
        >
          <FaPhone />
        </a>
        <div style={hoveredWidget === 'phone' ? tooltipVisibleStyle : tooltipStyle}>
          Call Us
        </div>
      </div>
    </div>
  );
}

export default FloatingWidgets;
